import { LectioJSUtils } from "../LectioJSUtils";
import { ILectioPlugin } from "./Types";

declare class Recorder {
	constructor(volume: any);

	public record(): any;
}


interface NavigatorEx {
    getUserMedia(
        options: { video?: boolean; audio?: boolean; },
        success: (stream: any) => void,
        error?: (error: string) => void
        ) : void;
}

export class PluginLectioAudioRecord implements ILectioPlugin {
	public Init(): void {
		function success(e: any) {
			// creates the audio context
			const winAny = window as any;
			const audioContext = winAny.AudioContext || winAny.webkitAudioContext;
			const context = (new audioContext()) as AudioContext & { createJavaScriptNode: any };

			// retrieve the current sample rate to be used for WAV packaging
			const sampleRate = context.sampleRate;

			// creates a gain node
			const volume = context.createGain();

			// creates an audio node from the microphone incoming stream
			const audioInput = context.createMediaStreamSource(e);

			// connect the stream to the gain node
			audioInput.connect(volume);

			/* From the spec: This value controls how frequently the audioprocess event is
			dispatched and how many sample-frames need to be processed each call.
			Lower values for buffer size will result in a lower (better) latency.
			Higher values will be necessary to avoid audio breakup and glitches */
			const bufferSize = 2048;
			const recorder = context.createJavaScriptNode(bufferSize, 2, 2);

			recorder.onaudioprocess = (e: any) => {
				LectioJSUtils.LogDebug('recording');
				const left = e.inputBuffer.getChannelData(0);
				const right = e.inputBuffer.getChannelData(1);
				// we clone the samples
				// leftchannel.push(new Float32Array(left));
				// rightchannel.push(new Float32Array(right));
				// recordingLength += bufferSize;
			};

			// we connect the recorder
			volume.connect(recorder);
			recorder.connect(context.destination);
		}

		const hiding = new Rx.Subject();
		CKEDITOR.plugins.add('lectioaudiorecord', {
			init: (editorOuter: CKEDITOR.editor) => {

				const getDialogDef = (editor: CKEDITOR.editor) => {
					const ddef: CKEDITOR.dialog.IDialogDefinition = {
						title: "Indsæt lydklip",
						minWidth: 400,
						minHeight: 150,
						contents: [
							{
								id: 'tab1',
								elements: [
									{
										type: 'button',
										label: 'Start optagelse',
										id: 'recordStart',
										onClick: (evt: any) => {
											const navigator = window.navigator as unknown as NavigatorEx;
											navigator.getUserMedia = navigator.getUserMedia ||
												(navigator as any).webkitGetUserMedia ||
												(navigator as any).mozGetUserMedia ||
												(navigator as any).msGetUserMedia;

											if (!navigator.getUserMedia) {
												alert('Din browser understøtter ikke lydoptagelse. Prøv en anden/nyere browser.');
												return;
											}
											const lad = {} as { wins?: MediaStream, mss?: any, vol?: any, rec?: any };
											(window as any).lectioaudiodebug = lad;

											navigator.getUserMedia({ audio: true }, stream => {
												LectioJSUtils.LogDebug('Fik mikrofon.', stream);
												lad.wins = stream;

												const onSuccess = (s: any) => {
													const context = new (AudioContext || (window as any).webkitAudioContext)();
													const audioInput = context.createMediaStreamSource(s);
													lad.mss = audioInput;

													const volume = context.createGain();
													audioInput.connect(volume);
													lad.vol = volume;

													//var url = URL.createObjectURL(s);
													//document.body.insertAdjacentHTML('beforeEnd', '<audio src="' + url + '" controls />');
													//return;

													const recorder = new Recorder(volume);
													lad.rec = recorder;
													recorder.record();

													// audio loopback
													volume.connect(context.destination);
												};

												onSuccess(stream);
											}, error => {
												console.error('Fik ikke mikrofon.', error);
											});
										},
										validate: () => {

											throw new Error('not impl');
											//const dialog = CKEDITOR.dialog.getCurrent();
											//const json = dialog.getContentElement('tab1', 'docInfoJson').getValue();
											//if (!json)
											//	return 'Der er ikke valgt en fil.';
											//const documentInfo = <SelectionDialogs.SelectedSerializedAnyFileId>JSON.parse(json);

											//const isok = !!(documentInfo.filename.match(/\.mp3$/) || documentInfo.filename.match(/\.m4a$/));
											//return isok ? null : 'Forkert filtype. Skal være mp3 eller m4a.';
										}
									}, {
										type: 'text',
										controlStyle: 'display: none',
										id: 'docInfoJson',
									} as any
								]
							}
						],
						onShow() {

						},
						onOk() {
							throw new Error('not impl');
							//const dialog = CKEDITOR.dialog.getCurrent();
							//const documentInfo = <SelectionDialogs.SelectedSerializedAnyFileId>JSON.parse(dialog.getContentElement('tab1', 'docInfoJson').getValue());

							//const audioimg = CKEDITOR.skin.icons.playaudio.path;
							//const url = LCDocumentEditorUtils.GetResourceUrl(documentInfo.serializedId, documentInfo.filename).replace(/"/g, '&quot;');
							//const html = '<img src="' + audioimg + '" width="24" height="24" data-lc-type="audio" data-lc-resource="' + url + '">';
							//editor.insertHtml(html);
						}
					};

					return ddef;
				};

				CKEDITOR.dialog.add('lectioAudioRecordDialog', getDialogDef);
				editorOuter.addCommand('lectioAudioRecord', new (CKEDITOR as any).dialogCommand('lectioAudioRecordDialog', {
					allowedContent: 'img[data-lc-type];img[data-lc-resource]',
					requiredContent: 'img[data-lc-resource]'
				}));

				editorOuter.ui.addButton('lectioAudioRecordButton', {
					label: "Optag lyd",
					command: "lectioAudioRecord",
					icon: CKEDITOR.skin.icons.audio!.path,
					toolbar: ''
				});
			}
		});
	}
}
